import React, { useState, useEffect } from 'react';
import { Button, Card, Form, FloatingLabel } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { Navigate } from "react-router-dom";
import { useAuth } from '../context/AuthContext';
import RegisterPage from './RegisterPage';
import { HiEye, HiEyeOff } from 'react-icons/hi';
import '../styles/Login.css';

const Login = () => {
    const { login, isAuthenticated, loading } = useAuth();
    const [loginInput, setLoginInput] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showRegister, setShowRegister] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async e => {
        e.preventDefault();
        setError("");
        setIsSubmitting(true);

        try {
            await login(loginInput, password);
            // Login bem-sucedido, o redirect será automático via PrivateRoute
        } catch (err) {
            console.error('Error sending data:', err);
            if (err.message) {
                setError(err.message);
            } else {
                setError("Erro ao fazer login. Verifique suas credenciais.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 vw-100 position-fixed top-0 start-0">
                <Spinner animation="grow" />
            </div>
        )
    }

    if (showRegister) {
        return <RegisterPage onVoltar={() => setShowRegister(false)} />;
    }

    return isAuthenticated() ? <Navigate to="/" /> : (
        <>
            <div
                className="d-flex flex-column justify-content-center align-items-center"
                style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
            >

                <Card style={{ width: "30rem", borderColor: "#003B6B" }}>
                    <Card.Header style={{
                        backgroundColor: "#003B6B",
                        color: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/image.png`}
                            alt="logo icon"
                            width="350px"
                            className="mb-2"
                        />
                    </Card.Header>
                    <Card.Body>
                        <Form onSubmit={handleLogin}>
                            <FloatingLabel controlId="userName" label="Login (e-mail/chave)" className="mb-3">
                                <Form.Control
                                    type="text"
                                    value={loginInput}
                                    onChange={(e) => setLoginInput(e.target.value)}
                                    placeholder="Digite seu usuário"
                                    required
                                    autoFocus
                                    disabled={isSubmitting}
                                />
                            </FloatingLabel>
                            <div style={{ position: 'relative' }}>
                                <FloatingLabel controlId="password" label="Senha" className="mb-3">
                                    <Form.Control
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Digite sua senha"
                                        required
                                        disabled={isSubmitting}
                                        style={{ paddingRight: '40px' }}
                                    />
                                </FloatingLabel>
                                <Button
                                    variant="link"
                                    onClick={() => setShowPassword(!showPassword)}
                                    disabled={isSubmitting}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        border: 'none',
                                        background: 'none',
                                        padding: '0',
                                        cursor: 'pointer',
                                        color: '#6c757d',
                                        zIndex: 10
                                    }}
                                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                >
                                    {showPassword ? <HiEyeOff size={20} /> : <HiEye size={20} />}
                                </Button>
                            </div>
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            <div className='row'>
                                <div className='col-2'>

                                </div>

                                <div className='col d-grid gap-2'>
                                    <div className="d-grid gap-2 text-center">
                                        <Button
                                            type="submit"
                                            variant="primary"
                                            size="lg"
                                            style={{ backgroundColor: "#003B6B", borderColor: "#003B6B" }}
                                            disabled={isSubmitting}
                                        >
                                            Entrar
                                        </Button>
                                    </div>
                                </div>

                                <div className='col-2'>

                                </div>
                            </div>

                            <div className='text-center mt-4'>
                                <a
                                    href='#'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowRegister(true);
                                    }}
                                    style={{ cursor: 'pointer', textDecoration: 'none', color: '#003B6B' }}
                                >
                                    Novo usuário
                                </a>

                            </div>

                        </Form>

                    </Card.Body>

                </Card>
                <div className="d-flex justify-content-center mt-2">
                    <img
                        src={`${process.env.PUBLIC_URL}/logo_labrisco.png`}
                        alt="logo icon"
                        width="250px"
                    />
                </div>
            </div>


        </>
    );
};

export default Login;